export default {
  catalog: {
    menu: {
      catalog: 'Catálogo',
    },
    breadcrumbs: {
      catalog: 'Catálogo',
      search: 'Búsqueda',
    },
    entity: {
      name: 'Nombre del ítem',
      description: 'Descripción del ítem',
      sku: 'SKU',
      code: 'Código',
      manufacturer: 'Fabricante',
      manufacturer_partnumber: 'Número de parte',
      uom: 'Unidad de medida',
      price: 'Precio',
      class: 'Clase',
      colloquial: 'Coloquial',
      keywords: 'Palabras clave',
      currency: 'Moneda',
      category: 'Clase',
      noun: 'Nombre del Elemento',
      modifier: 'Modificador',
      has_stock: 'Stock disponible (materiales)',
      is_obsolete: 'Se encuentra obsoleto (materiales)',
      is_active: 'Se encuentra activo',
      technical_specification: 'Descripción',
      updated_at: 'Fecha de actualización',
      equivalences: 'Equivalencias',
    },
    pages: {
      '_admin-manage-products': {
        title: 'Administrador de ítems',
        actions: {
          create: {
            title: 'Crear ítem',
            help: 'Opción para crear un ítem nuevo en el catálogo',
          },
        },
      },
      '_admin-manage-product': {
        title: 'Administrar ítem',
        validation: {
          message: 'Tienes campos requeridos sin completar',
        },
        entity: {
          help: {
            name: 'Esta es una descripción corta que no contiene toda la especificación del ítem, pero permite entender con cierto detalle de que tipo de ítem se trata.',
            description: 'En este campo se debe agregar todos los detalles de la descripción, incluyendo todas las especificaciones técnicas que tenga disponible.',
            price: 'Este valor corresponde al precio de lista o referencial.',
            modifier: 'Es la característica más relevante del ítem. Ej: BOLA (en RODAMIENTO DE BOLA), ELECTRICO (en MOTOR ELECTRICO), HIDRAULICA (en BOMBA HIDRAULICA). Ingresarlo sin tilde.',
          },
        },
        actions: {
          add_equivalences: 'Agregar Equivalencia',
          download: 'Descargar',
          remove: 'Eliminar',
          publish: 'Publicar',
          see: 'Ver Ficha',
          restore: 'Restaurar',
          save_changes: 'Guardar Cambios',
          create_new: 'Crear Solicitud',
        },
      },
      search: {
        title: 'Búsqueda de ítems',
        placeholders: {
          searchBy: 'Buscar por palabras clave...',
        },
        filters: {
          status: {
            title: 'Estado Ítem',
            options: {
              all: 'Todos',
              published_at_is_not_null: 'Sólo ítems publicados',
              published_at_is_null: 'Sólo ítems sin publicar',
            },
          },
          price: {
            title: 'Precio Ítem',
            options: {
              all: 'Todos',
              price_gte_1_lte_null: 'Sólo ítems con precio mayor a 0',
              price_gte_0_lte_0: 'Sólo ítems con precio 0',
            },
          },
          unpublished: 'Sin publicar',
        },
        actions: {
          search: 'Buscar',
          edit: 'Editar',
        },
      },
      product: {
        title: 'Ítem',
        tabs: {
          attributes: 'Atributos',
          manufacturer: 'Fabricante (materiales)',
          classification: 'Clasificación',
          attachment: 'Adjuntos',
          general: 'Información General',
          stock: 'Stock (materiales)',
          technical_specification: 'Información adicional',
          equivalences: 'Equivalencias (materiales)',
        },
        tables: {
          attributes: {
            headers: {
              position: 'Posición',
              attribute: 'Atributo',
              value: 'Valor',
            },
          },
          attachment: {
            headers: {
              filename: 'Nombre del archivo',
              action: 'Acción',
            },
          },
          stock: {
            headers: {
              quantity: 'Cantidad',
              uom: 'UOM',
              country: 'País',
              city: 'Ciudad',
            },
          },
          technical_specification: {
            headers: {
              title: 'Especificación',
            },
          },
        },
        actions: {
          catalog: 'Ir al catálogo',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/catalog.js